import api from "./api";
import { track } from "./track";
import { toast } from "sonner";

export function loadRazorpay() {
    return new Promise((resolve) => {
        if (window.Razorpay) return resolve(true);
        const s = document.createElement("script");
        s.src = "https://checkout.razorpay.com/v1/checkout.js";
        s.onload = () => resolve(true);
        s.onerror = () => resolve(false);
        document.body.appendChild(s);
    });
}

// Reusable Razorpay checkout for courses & products.
// Returns true on verified payment, false otherwise. Fires Meta Pixel events.
export async function startCheckout({ kind, slug, onSuccess }) {
    try {
        const cfg = await api.get("/payments/config");
        if (!cfg.data?.enabled) { toast.error("Payments are not available right now."); return false; }
        const ok = await loadRazorpay();
        if (!ok) { toast.error("Could not load payment. Please try again."); return false; }
        const { data } = await api.post("/payments/create-order", { kind, slug });
        const amt = Number(data.amount) / 100 || 0;
        track("InitiateCheckout", { value: amt, currency: data.currency || "INR", content_name: data.name, content_type: kind, content_ids: [slug], num_items: 1 });
        return await new Promise((resolve) => {
            const rzp = new window.Razorpay({
                key: data.key_id, amount: data.amount, currency: data.currency, order_id: data.order_id,
                name: data.name || "MUVIARTS", description: kind === "course" ? "Course enrolment" : "Digital product",
                prefill: { name: data.user_name || "", email: data.email || "" }, theme: { color: "#c0a15a" },
                handler: async (r) => {
                    try {
                        await api.post("/payments/verify", { kind, slug, razorpay_order_id: r.razorpay_order_id, razorpay_payment_id: r.razorpay_payment_id, razorpay_signature: r.razorpay_signature });
                        track("Purchase", { value: amt, currency: data.currency || "INR", content_name: data.name, content_type: kind, content_ids: [slug], num_items: 1 }, { eventID: r.razorpay_order_id });
                        toast.success("Payment successful!");
                        await onSuccess?.();
                        resolve(true);
                    } catch { toast.error("Payment verification failed. Please contact support."); resolve(false); }
                },
                modal: { ondismiss: () => resolve(false) },
            });
            rzp.open();
        });
    } catch (e) {
        toast.error(e?.response?.data?.detail || "Something went wrong.");
        return false;
    }
}
